/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkGetCustomerBioDetailRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/bulk_get_customer_bio.pb'
import {BulkGetCustomerBioDetailResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/bulk_get_customer_bio.pb'


export const bulkGetCustomerBioDetail = (request: BulkGetCustomerBioDetailRequest, options?: CashRequestOptions) => post<BulkGetCustomerBioDetailRequest, BulkGetCustomerBioDetailResponse>("/2.0/cash/bulk-get-customer-bio-detail", request, {...options, rejectOnError: true })